// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__rcYz8","tab":"Tabs_tab__h8pDE","tabActive":"Tabs_tabActive__3MlRS"};